import { Layout } from 'antd';
import Sidebar from "../sidebar/Sidebar";
import NavbarSidebar from "../navbar/NavbarSidebar";
import ProtectedRoute from "../../routers/ProtectedRouter";
import { useState, useEffect } from "react";

const { Content } = Layout;

const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });
  const [marginLeft, setMarginLeft] = useState(collapsed ? 80 : 260);

  useEffect(() => {
    setMarginLeft(collapsed ? 80 : 260);
  }, [collapsed]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Layout> {/* Removed marginTop: 60 */}
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        <Layout style={{ marginLeft: marginLeft, transition: 'margin-left 0.2s' }}>
          <NavbarSidebar />
          <Content
            style={{
              margin: '24px 16px',
              padding: 24,
              minHeight: 280,
              background: '#fff',
              borderRadius: '15px', // Rounded edge
              overflow: 'initial'
            }}
          >
            <ProtectedRoute />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AppLayout;